import React, { Fragment } from 'react'
// import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Grid } from '@material-ui/core'
import './information-invited.css'

const InformationADAkubicaFirmaDigitalInvitedPure = (props) => {
    const { t } = useTranslation()

    return (
        <Fragment>
            {/* Column You interest in hibou.legal */}
            <Grid item xs={6} lg={6} md={6} sm={6} es={6}>
                <Grid container xs={12} lg={12} md={12} sm={12} es={12} spacing={2}>
                    <Grid item lg={12} md={12} sm={12} es={12} xs={12}>
                        <h3 className="information-contact-invited-ad-h3">{t('informationContactInvited.titleAksMifirma')}</h3>
                        <p className="information-contact-invited-ad-label">{t('informationContactInvited.labelNoWaitToBuySigns')}</p>
                        <span className="btn-invited-ad-button" onClick={props.onInvitedRedirectRegister} >{t('informationContactInvited.labelBuySigns')}</span>
                    </Grid>
                </Grid>
            </Grid>
            {/* Column Image */}
            <Grid item xs={6} lg={6} md={6} sm={6} es={6}>
                <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
                    <Grid item lg={12} md={12} sm={12} es={12} xs={12}>
                        <img src="https://i.ibb.co/B2R4mvR/publicidad-usuario.jpg" alt="publicidad_usuario" width={439} />
                    </Grid>
                </Grid>
            </Grid>
        </Fragment>
    )
}
export { InformationADAkubicaFirmaDigitalInvitedPure as default }